import { Trans } from 'react-i18next'

import { InfoPageStyles as S } from '~/pages/communication/libs/InfoPage/styles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

interface IInfoPageProps extends TPageProps {
  question: string
  titleI18nKey: string
  subtitleI18nKey: string
  imagePng: string
  imageWebp: string
  imageAlt: string
  ns?: string
  contentGap?: number
  imageFade?: boolean
}

const InfoPage = ({
  nextPagePath,
  pageId,
  question,
  titleI18nKey,
  subtitleI18nKey,
  imagePng,
  imageWebp,
  imageAlt,
  ns = 'communication',
  contentGap,
  imageFade,
}: IInfoPageProps) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question,
  })

  return (
    <S.Root>
      <S.ContentWrapper $gap={contentGap}>
        <S.Title>
          <Trans ns={ns} i18nKey={titleI18nKey} />
        </S.Title>

        <S.ImageWrapper $withFade={imageFade}>
          <picture>
            <source srcSet={imageWebp} type="image/webp" />
            <img src={imagePng} alt={imageAlt} />
          </picture>
        </S.ImageWrapper>

        <S.Subtitle>
          <Trans
            ns={ns}
            i18nKey={subtitleI18nKey}
            components={{ strong: <strong /> }}
          />
        </S.Subtitle>

        <S.Button type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.Button>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default InfoPage
